<script>
import { mapState } from "vuex";
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import Matriz from "@/components/widgets/network-matriz";

export default {
  locales: {
    pt: {},
    es: {},
  },
  components: {
    Layout,
    Matriz,
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  data() {
    return {
      loading: false,
      matriz: null,
      detailModalOpen: false,
      selectedUser: null,
    };
  },
  methods: {
    onSelectNode(payload) {
      this.selectedUser = payload;
      this.detailModalOpen = true;
    },
    getMatriz() {
      this.loading = true;

      api.get("network/matriz").then((response) => {
        if (response.data.status == "success") {
          this.matriz = response.data.matriz;
        } else {
          this.matriz = null;
        }

        this.loading = false;
      });
    },
  },
  mounted() {
    this.getMatriz();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">Equipe</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>Árvore</h3>
        <p></p>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <Matriz :data="matriz" @select-node="onSelectNode"></Matriz>
      </div>
    </div>

    <b-modal
      id="matriz-user-detail"
      v-model="detailModalOpen"
      title="Detalhes"
      modal-class="modal-right"
      hide-footer
    >
      <div v-if="selectedUser">
        <div class="text-center mb-4">
          <img
            v-if="selectedUser.avatar"
            class="rounded-circle header-profile-user"
            :src="selectedUser.avatar"
            alt=""
            style="width: 80px; height: 80px; object-fit: cover"
          />
          <img
            v-else
            class="rounded-circle header-profile-user"
            :src="
              'https://ui-avatars.com/api/?background=332EB3&color=fff&name=' +
              encodeURIComponent(selectedUser.name || 'U')
            "
            alt=""
            style="width: 80px; height: 80px"
          />
        </div>
        <div class="text-center">
          <h4>{{ selectedUser.name }}</h4>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
